export enum PaymentTypeAction {
	download = 'download',
	view_invoice = 'view_invoice',
	view_order = 'view_order',
	confirm_payment = 'confirm_payment',
	extend_invoice = 'extend_invoice',
	paid_payment = 'paid_payment',
}
